import React from 'react'
import { Button, Card, Col, Form } from 'react-bootstrap';
import Payment from './Payment';
import { deepCopy } from '../../Components/Shared/Utility/DeepCopy';
import { PaymentType } from './PaymentType';
import { FattPayCreditCard } from './FattPayCreditCard';
import { FattPayBank } from './FattPayBank';

interface IFattPayContainerProps {
    onPaymentChanged: (payment: Payment) => void;
    onPaymentTypeChanged: () => void;
    payment: Payment,
    disabled?: boolean
}

export const FattPayContainer = React.forwardRef((props: IFattPayContainerProps, ref: React.Ref<any>) => {
    const ccPaymentRef = React.useRef(null);

    React.useImperativeHandle(ref,
        () => ({
            validate(payment: Payment) : boolean {
                var isValid = true;

                if (ccPaymentRef.current && !ccPaymentRef.current.validate(payment)) {
                    isValid = false;
                }

                return isValid;
            }
        }),
    );

    
    const updatePaymentType = (paymentType: PaymentType) => {
        const updated = deepCopy(props.payment);
        updated.paymentType = paymentType;
        props.onPaymentChanged(updated);
        props.onPaymentTypeChanged();
    }

    const updateFirstName = (firstName: string) => {
        const updated = deepCopy(props.payment);
        updated.firstName = firstName;
        props.onPaymentChanged(updated);
    }

    const updateLastName = (lastName: string) => {
        const updated = deepCopy(props.payment);
        updated.lastName = lastName;
        props.onPaymentChanged(updated);
    }

    return (
        <React.Fragment>
            <div>
                <Card.Text className="font-weight-bolder mb-1 pp-font-size-smaller mt-3">
                    Select Payment Method<span className="text-pp-primary ml-2">*</span>
                </Card.Text>
                <Button variant={props.payment.paymentType == PaymentType.CreditCard ? "pp-primary" : "outline-pp-primary"} disabled={props.disabled} onClick={() => updatePaymentType(PaymentType.CreditCard)}>Credit Card</Button>
                <Button variant={props.payment.paymentType == PaymentType.ECheck ? "pp-primary" : "outline-pp-primary"} disabled={props.disabled} onClick={() => updatePaymentType(PaymentType.ECheck)}>eCheck</Button>
            </div>
            { props.payment.paymentType &&
                <React.Fragment>
                    <Form.Group className="mt-4">
                        <Form.Label className="font-weight-bolder mb-1 pp-font-size-smaller">Cardholder Name
                            <span className="text-pp-primary ml-2">*</span></Form.Label>
                        <Form.Row>
                            <Col>
                                <Form.Control type="input" required placeholder="First" isInvalid={props.payment.error?.field === "first_name"}
                                    onChange={(e) => updateFirstName(e.target.value)}
                                    defaultValue={props.payment.firstName} />
                                <Form.Control.Feedback type="invalid">First Name is Required</Form.Control.Feedback>
                            </Col>
                            <Col>
                                <Form.Control type="input" required placeholder="Last" isInvalid={props.payment.error?.field === "last_name"}
                                    onChange={(e) => updateLastName(e.target.value)}
                                    defaultValue={props.payment.lastName} />
                                <Form.Control.Feedback type="invalid">Last Name is Required</Form.Control.Feedback>
                            </Col>
                        </Form.Row>
                    </Form.Group>
                    {props.payment.paymentType === PaymentType.CreditCard &&
                        <FattPayCreditCard ref={ccPaymentRef} payment={props.payment} onPaymentChanged={props.onPaymentChanged} />
                    }
                    {props.payment.paymentType === PaymentType.ECheck &&
                        <FattPayBank payment={props.payment} onPaymentChanged={props.onPaymentChanged} />
                    }
                </React.Fragment>
            }
        </React.Fragment>
    );
});